export interface WorkspaceSettingsUpdateInput {
  name: string;
  description: string;
  assistantInstructions: string;
  enabledModules: string[];
  skillInvocationAttributionEnabled: boolean;
  followUpSuggestionsEnabled: boolean;
}

export const buildWorkspaceSettingsUpdatePayload = ({
  name,
  description,
  assistantInstructions,
  enabledModules,
  skillInvocationAttributionEnabled,
  followUpSuggestionsEnabled,
}: WorkspaceSettingsUpdateInput) => ({
  name,
  description,
  assistant_instructions: assistantInstructions,
  enabled_modules: enabledModules,
  features: {
    skill_invocation_attribution: skillInvocationAttributionEnabled,
    ida_follow_up_suggestions: followUpSuggestionsEnabled,
  },
});
